import { GoogleTagManager } from "@next/third-parties/google";

// Marketing GTM container — mount on public (unauthenticated) surfaces only.
// The container is shared with descripio.com and carries ad pixels (FB, LinkedIn,
// Google Ads) that must not load on authenticated app pages.
export default function PublicGtm() {
  if (!process.env.NEXT_PUBLIC_GTM_ID) return null;
  return <GoogleTagManager gtmId={process.env.NEXT_PUBLIC_GTM_ID} data-sentry-element="GoogleTagManager" data-sentry-component="PublicGtm" data-sentry-source-file="PublicGtm.jsx" />;
}